import React from 'react'
import { cleanFormLayout } from './common/cleanFormLayout'
import { basicTemplate4Layout } from './common/basicTemplate4Layout'
import { basicTemplate5Layout } from './common/basicTemplate5Layout'
import { defaultLayout } from './common/defaultLayout'
import { hanwhaSectionsLayout } from './common/hanwhaSectionsLayout'
import {
  leadGenFullbleedLayoutsByCategory,
  leadGenFullbleedLegacyLayout,
} from './common/leadGenFullbleedLayout'

export { isLeadGenFullbleedLayoutKey, leadGenFullbleedTemplateStyleForCategory } from './common/leadGenFullbleedLayout'

const CATEGORY_LANDING_LAYOUTS = [
  defaultLayout,
  cleanFormLayout,
  hanwhaSectionsLayout,
  basicTemplate4Layout,
  basicTemplate5Layout,
  ...leadGenFullbleedLayoutsByCategory,
]

function getCategoryLandingLayouts(category) {
  return CATEGORY_LANDING_LAYOUTS.filter((layout) => (
    typeof layout.supportsCategory !== 'function' || layout.supportsCategory(category)
  ))
}

function getCategoryLandingLayout(layoutKey) {
  const found = CATEGORY_LANDING_LAYOUTS.find((layout) => layout.key === layoutKey)
  if (found) return found
  if (layoutKey === 'lead-gen-fullbleed') {
    return leadGenFullbleedLegacyLayout
  }
  return defaultLayout
}

export function getCategoryLandingLayoutOptions(category) {
  return getCategoryLandingLayouts(category).map((layout) => ({
    value: layout.key,
    label: layout.label,
    description: layout.description || '',
  }))
}

export function getCategoryLandingLayoutEditableFields(layoutKey) {
  return getCategoryLandingLayout(layoutKey)?.editableConfigFields || []
}

function coerceCustomConfigInput(customConfig) {
  if (customConfig == null || customConfig === '') return {}
  if (typeof customConfig === 'string') {
    const s = customConfig.trim()
    if (!s) return {}
    try {
      const parsed = JSON.parse(s)
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {}
    } catch {
      return {}
    }
  }
  if (typeof customConfig === 'object' && !Array.isArray(customConfig)) return customConfig
  return {}
}

export function normalizeCategoryLandingLayoutConfig(customConfig = {}) {
  const cfg = coerceCustomConfigInput(customConfig)
  const layoutKey = cfg.templateStyle || 'default'
  const layout = getCategoryLandingLayout(layoutKey)
  return layout.normalizeCustomConfig ? layout.normalizeCustomConfig(cfg) : { ...cfg, templateStyle: layoutKey }
}

export function applyCategoryLandingLayout(layoutKey, currentConfig = {}) {
  const layout = getCategoryLandingLayout(layoutKey)
  return layout.normalizeCustomConfig ? layout.normalizeCustomConfig(currentConfig || {}) : { ...(currentConfig || {}), templateStyle: layoutKey }
}

export function renderCategoryLandingLayout(layoutKey, props) {
  const layout = getCategoryLandingLayout(layoutKey)
  const Component = layout.Component
  return <Component {...props} />
}
